import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../../../types/titles';
import WithdrawOTPLayout from '../../../../components/withdraw/twofa/otp';

const WithdrawOTP = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.WITHDRAW.TWO_FA.OTP}</title>
			</Helmet>
			<WithdrawOTPLayout />
		</>
	);
};

export default WithdrawOTP;
